import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  //

  createChannel = new Subject();
  detailChannel = new Subject();
  employeeChannel = new Subject();
  typeChannel = new Subject();
  typeStopChannel = new Subject();
  documentChannel = new Subject();
  dmsListChannel = new Subject();
  documentListChannel = new Subject();
  repository = new CreateRepository();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.typeChannel.next({ status: apiResponse.INITIAL });
    this.typeStopChannel.next({ status: apiResponse.INITIAL });
    this.documentChannel.next({ status: apiResponse.INITIAL });
    this.dmsListChannel.next({ status: apiResponse.INITIAL });
    this.documentListChannel.next({ status: apiResponse.INITIAL });
  }

  typeStopChannel;

  fetchCreate = async (query) => {
    this.createChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchCreate(query)
      .then((result) => {
        this.createChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.createChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchEmployee = async (query) => {
    this.employeeChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchEmployee(query)
      .then((result) => {
        this.employeeChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.employeeChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchType = async (query) => {
    this.typeChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchType(query)
      .then((result) => {
        this.typeChannel.next({ status: apiResponse.COMPLETED, data: result });
      })
      .catch((error) => {
        this.typeChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchTypeStop = async (query) => {
    this.typeStopChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchType(query)
      .then((result) => {
        this.typeStopChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.typeStopChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchDetail = async (query) => {
    this.detailChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchDetail(query)
      .then((result) => {
        this.detailChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.detailChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchDocument = async (query) => {
    this.documentChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchDocument(query)
      .then((result) => {
        this.documentChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.documentChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchDMSList = async (query) => {
    try {
      this.dmsListChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDMSList(query)
        // .then((result) => {
        //   console.log(result);
        //   return result;
        // })
        .then((result) => {
          this.dmsListChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.dmsListChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("catch : ");
      console.log(error);
    }
  };

  fetchDocumentList = async (query) => {
    try {
      this.documentListChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDocumentList(query)
        .then((result) => {
          this.documentListChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.documentListChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("catch : ");
      console.log(error);
    }
  };
}

export default CreateBloc;
